/**
 * Proves who someone is and hands back a short-lived ID token, which the API turns into the HttpOnly
 * session cookie. The provider (Firebase today) sits behind this interface; nothing else imports it.
 * The provider keeps nothing in the browser after sign-in (in-memory only, cleared right away).
 */
export interface IdentityAdapter {
  signInWithGoogle(): Promise<string>;
  signInWithEmail(email: string, password: string): Promise<string>;
  sendPasswordReset(email: string): Promise<void>;
  /** Forgets the provider's own sign-in once the API session exists. */
  clear(): Promise<void>;
}

/** Why sign-in failed, in words for people. `cancelled` means the user closed the popup: say nothing. */
export class IdentityError extends Error {
  constructor(
    readonly reason:
      "invalid-credentials" | "cancelled" | "too-many-attempts" | "network" | "not-configured" | "other",
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "IdentityError";
  }
}
